cobalt-tabs-horizontal {
  display: block;
}

.cobalt-tabs--horizontal {
  display: flex;
  flex-direction: column;
}

.cobalt-tabs--horizontal .list-header-wrapper {
  display: flex;
  align-items: center;
}

/* override scroll styles */
.cobalt-tabs--horizontal .cobalt-tabs-list-header {
  width: 100%;
  padding: 2px 0;
  overflow-x: auto;
  box-sizing: border-box;
  scrollbar-color: transparent transparent;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.cobalt-tabs--horizontal .cobalt-tabs-list-header::-webkit-scrollbar {
  width: 0;
}
.cobalt-tabs--horizontal .cobalt-tabs-list-header::-webkit-scrollbar-track {
  background: transparent;
}
.cobalt-tabs--horizontal .cobalt-tabs-list-header::-webkit-scrollbar-thumb {
  background: transparent;
  border: none;
}

/* list styles */
.cobalt-tabs--horizontal .cobalt-tabs-list {
  display: flex;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}

.cobalt-tabs--horizontal .cobalt-tab-item {
  cursor: pointer;
  position: relative;
  display: flex;
  border-radius: var(--number-radius-small);
  padding: 0 var(--number-spacing-small);
  background-color: var(--color-selection-secondary-background-default);
  color: var(--color-selection-secondary-content-default);
}

.cobalt-tabs--horizontal .tab-item--stretch {
  flex: 1;
}

.cobalt-tabs--horizontal .tab-item--icon-left {
  justify-content: center;
}

.cobalt-tabs--horizontal .tab-item--icon-top {
  align-items: center;
  justify-content: center;
}

.cobalt-tabs--horizontal .tab-item--disabled {
  cursor: not-allowed;
  color: var(--color-global-all-disabled-strong)
}

.cobalt-tabs--horizontal .tab-item--selected {
  position: relative;
  background-color: var(--color-selection-secondary-background-selected);
  color: var(--color-selection-secondary-content-selected);
}

.cobalt-tabs--horizontal .tab-item--icon-left .tab-label-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: var(--number-spacing-small) 0;
}

.cobalt-tabs--horizontal .tab-item--icon-top .tab-label-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--number-spacing-2xsmall) 0;
}

.cobalt-tabs--horizontal .tab-label-content {
  position: relative;
  align-items: center;
  gap: var(--number-spacing-4xsmall);
}

.cobalt-tabs--horizontal .tab-item--selected .tab-label-content::after {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  height: 2px;
  width: 100%;
  margin-top: calc(var(--number-spacing-small) - 2px); /* padding bottom minus indicator height */
  background-color: var(--color-selection-secondary-content-selected);
}

.cobalt-tabs--horizontal .tab-label-content .tab-label {
  flex-grow: 1;
  text-wrap: nowrap;
}

.cobalt-tabs--horizontal .cobalt-tab-item:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  z-index: 1000; /* make sure outline is always on top of sibling elements */
}

.cobalt-tabs--horizontal .cobalt-tab-item:not(.tab-item--disabled):not(.tab-item--selected):hover, .cobalt-tabs--horizontal .cobalt-tab-item:not(.tab-item--disabled):not(.tab-item--selected):focus-visible {
  background-color: var(--color-selection-secondary-background-interacting);
  color: var(--color-selection-secondary-content-interacting);
}

.cobalt-tabs--horizontal .icon-box {
  position: relative;
}

.cobalt-tabs--horizontal .tab-item--icon-top .cobalt-notification-pill {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(50%, -50%);
}

.cobalt-tabs--horizontal .tab-content {
  flex-grow: 1;
}

.cobalt-tabs--horizontal .previous-button {
  width: var(--number-size-icon-3xlarge);
  opacity: 1;
  border-radius: var(--number-radius-medium);
  box-shadow: var(--effect-drop-medium);
  transition: width var(--motion-duration-medium) var(--motion-easing-move);
}

.cobalt-tabs--horizontal .previous-button--hidden {
  width: 0;
  opacity: 0;
}

.cobalt-tabs--horizontal .next-button {
  width: var(--number-size-icon-3xlarge);
  opacity: 1;
  border-radius: var(--number-radius-medium);
  box-shadow: var(--effect-drop-medium);
  transition: width var(--motion-duration-medium) var(--motion-easing-move);
}

.cobalt-tabs--horizontal .next-button--hidden {
  width: 0;
  opacity: 0;
}
